import { widgetLoader, widgetReLoader } from './widgetLoader';

(window as any).rentifyWidgetReLoader = widgetReLoader;

widgetLoader();
